var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-img',{staticClass:"screenshot",attrs:{"center":"","src":_vm.screenshotURL}}),_c('div',{staticClass:"screenshot-ts"},[_c('b-icon',{attrs:{"icon":"arrow-clockwise"}}),_vm._v(_vm._s(_vm.screenshotTimestamp))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }